/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as SettingsWorkspacesRouteImport } from './routes/settings/workspaces'
import { Route as SettingsProvidersRouteImport } from './routes/settings/providers'
import { Route as SettingsOrganizationRouteImport } from './routes/settings/organization'
import { Route as SettingsChannelsRouteImport } from './routes/settings/channels'
import { Route as DashboardUsageRouteImport } from './routes/dashboard/usage'
import { Route as DashboardBillingRouteImport } from './routes/dashboard/billing'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as DashboardAgentsIndexRouteImport } from './routes/dashboard/agents/index'
import { Route as SettingsOpsSecretsRouteImport } from './routes/settings/ops/secrets'
import { Route as SettingsOpsHostingRouteImport } from './routes/settings/ops/hosting'
import { Route as SettingsOpsChannelsRouteImport } from './routes/settings/ops/channels'
import { Route as DashboardAgentsAgentIdRouteImport } from './routes/dashboard/agents/$agentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkspacesRoute = SettingsWorkspacesRouteImport.update({
  id: '/settings/workspaces',
  path: '/settings/workspaces',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/settings/providers',
  path: '/settings/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/settings/organization',
  path: '/settings/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsChannelsRoute = SettingsChannelsRouteImport.update({
  id: '/settings/channels',
  path: '/settings/channels',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsageRoute = DashboardUsageRouteImport.update({
  id: '/dashboard/usage',
  path: '/dashboard/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardBillingRoute = DashboardBillingRouteImport.update({
  id: '/dashboard/billing',
  path: '/dashboard/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAgentsIndexRoute = DashboardAgentsIndexRouteImport.update({
  id: '/dashboard/agents/',
  path: '/dashboard/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOpsSecretsRoute = SettingsOpsSecretsRouteImport.update({
  id: '/settings/ops/secrets',
  path: '/settings/ops/secrets',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOpsHostingRoute = SettingsOpsHostingRouteImport.update({
  id: '/settings/ops/hosting',
  path: '/settings/ops/hosting',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOpsChannelsRoute = SettingsOpsChannelsRouteImport.update({
  id: '/settings/ops/channels',
  path: '/settings/ops/channels',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAgentsAgentIdRoute = DashboardAgentsAgentIdRouteImport.update({
  id: '/dashboard/agents/$agentId',
  path: '/dashboard/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/dashboard/billing': typeof DashboardBillingRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/dashboard/agents/$agentId': typeof DashboardAgentsAgentIdRoute
  '/settings/ops/channels': typeof SettingsOpsChannelsRoute
  '/settings/ops/hosting': typeof SettingsOpsHostingRoute
  '/settings/ops/secrets': typeof SettingsOpsSecretsRoute
  '/dashboard/agents/': typeof DashboardAgentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/dashboard/billing': typeof DashboardBillingRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/dashboard': typeof DashboardIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/dashboard/agents/$agentId': typeof DashboardAgentsAgentIdRoute
  '/settings/ops/channels': typeof SettingsOpsChannelsRoute
  '/settings/ops/hosting': typeof SettingsOpsHostingRoute
  '/settings/ops/secrets': typeof SettingsOpsSecretsRoute
  '/dashboard/agents': typeof DashboardAgentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/dashboard/billing': typeof DashboardBillingRoute
  '/dashboard/usage': typeof DashboardUsageRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/workspaces': typeof SettingsWorkspacesRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/dashboard/agents/$agentId': typeof DashboardAgentsAgentIdRoute
  '/settings/ops/channels': typeof SettingsOpsChannelsRoute
  '/settings/ops/hosting': typeof SettingsOpsHostingRoute
  '/settings/ops/secrets': typeof SettingsOpsSecretsRoute
  '/dashboard/agents/': typeof DashboardAgentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/login'
    | '/auth/register'
    | '/dashboard/billing'
    | '/dashboard/usage'
    | '/settings/channels'
    | '/settings/organization'
    | '/settings/providers'
    | '/settings/workspaces'
    | '/dashboard/'
    | '/settings/'
    | '/dashboard/agents/$agentId'
    | '/settings/ops/channels'
    | '/settings/ops/hosting'
    | '/settings/ops/secrets'
    | '/dashboard/agents/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/login'
    | '/auth/register'
    | '/dashboard/billing'
    | '/dashboard/usage'
    | '/settings/channels'
    | '/settings/organization'
    | '/settings/providers'
    | '/settings/workspaces'
    | '/dashboard'
    | '/settings'
    | '/dashboard/agents/$agentId'
    | '/settings/ops/channels'
    | '/settings/ops/hosting'
    | '/settings/ops/secrets'
    | '/dashboard/agents'
  id:
    | '__root__'
    | '/'
    | '/auth/login'
    | '/auth/register'
    | '/dashboard/billing'
    | '/dashboard/usage'
    | '/settings/channels'
    | '/settings/organization'
    | '/settings/providers'
    | '/settings/workspaces'
    | '/dashboard/'
    | '/settings/'
    | '/dashboard/agents/$agentId'
    | '/settings/ops/channels'
    | '/settings/ops/hosting'
    | '/settings/ops/secrets'
    | '/dashboard/agents/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  DashboardBillingRoute: typeof DashboardBillingRoute
  DashboardUsageRoute: typeof DashboardUsageRoute
  SettingsChannelsRoute: typeof SettingsChannelsRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsWorkspacesRoute: typeof SettingsWorkspacesRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  DashboardAgentsAgentIdRoute: typeof DashboardAgentsAgentIdRoute
  SettingsOpsChannelsRoute: typeof SettingsOpsChannelsRoute
  SettingsOpsHostingRoute: typeof SettingsOpsHostingRoute
  SettingsOpsSecretsRoute: typeof SettingsOpsSecretsRoute
  DashboardAgentsIndexRoute: typeof DashboardAgentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/workspaces': {
      id: '/settings/workspaces'
      path: '/settings/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof SettingsWorkspacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/settings/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/channels': {
      id: '/settings/channels'
      path: '/settings/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof SettingsChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/usage': {
      id: '/dashboard/usage'
      path: '/dashboard/usage'
      fullPath: '/dashboard/usage'
      preLoaderRoute: typeof DashboardUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/billing': {
      id: '/dashboard/billing'
      path: '/dashboard/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof DashboardBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/agents/': {
      id: '/dashboard/agents/'
      path: '/dashboard/agents'
      fullPath: '/dashboard/agents/'
      preLoaderRoute: typeof DashboardAgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ops/secrets': {
      id: '/settings/ops/secrets'
      path: '/settings/ops/secrets'
      fullPath: '/settings/ops/secrets'
      preLoaderRoute: typeof SettingsOpsSecretsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ops/hosting': {
      id: '/settings/ops/hosting'
      path: '/settings/ops/hosting'
      fullPath: '/settings/ops/hosting'
      preLoaderRoute: typeof SettingsOpsHostingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ops/channels': {
      id: '/settings/ops/channels'
      path: '/settings/ops/channels'
      fullPath: '/settings/ops/channels'
      preLoaderRoute: typeof SettingsOpsChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/agents/$agentId': {
      id: '/dashboard/agents/$agentId'
      path: '/dashboard/agents/$agentId'
      fullPath: '/dashboard/agents/$agentId'
      preLoaderRoute: typeof DashboardAgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  DashboardBillingRoute: DashboardBillingRoute,
  DashboardUsageRoute: DashboardUsageRoute,
  SettingsChannelsRoute: SettingsChannelsRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsWorkspacesRoute: SettingsWorkspacesRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  DashboardAgentsAgentIdRoute: DashboardAgentsAgentIdRoute,
  SettingsOpsChannelsRoute: SettingsOpsChannelsRoute,
  SettingsOpsHostingRoute: SettingsOpsHostingRoute,
  SettingsOpsSecretsRoute: SettingsOpsSecretsRoute,
  DashboardAgentsIndexRoute: DashboardAgentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
